/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardProviderTier } from './RewardProviderTier';
import {
    RewardProviderTierFromJSON,
    RewardProviderTierFromJSONTyped,
    RewardProviderTierToJSON,
    RewardProviderTierToJSONTyped,
} from './RewardProviderTier';
import type { RewardType } from './RewardType';
import {
    RewardTypeFromJSON,
    RewardTypeFromJSONTyped,
    RewardTypeToJSON,
    RewardTypeToJSONTyped,
} from './RewardType';
import type { DurationUnit } from './DurationUnit';
import {
    DurationUnitFromJSON,
    DurationUnitFromJSONTyped,
    DurationUnitToJSON,
    DurationUnitToJSONTyped,
} from './DurationUnit';
import type { AmountUnit } from './AmountUnit';
import {
    AmountUnitFromJSON,
    AmountUnitFromJSONTyped,
    AmountUnitToJSON,
    AmountUnitToJSONTyped,
} from './AmountUnit';
import type { EmailTemplate } from './EmailTemplate';
import {
    EmailTemplateFromJSON,
    EmailTemplateFromJSONTyped,
    EmailTemplateToJSON,
    EmailTemplateToJSONTyped,
} from './EmailTemplate';
import type { AssetResponse } from './AssetResponse';
import {
    AssetResponseFromJSON,
    AssetResponseFromJSONTyped,
    AssetResponseToJSON,
    AssetResponseToJSONTyped,
} from './AssetResponse';

/**
 * 
 * @export
 * @interface RewardConfigResponse
 */
export interface RewardConfigResponse {
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    id: string;
    /**
     * 
     * @type {RewardType}
     * @memberof RewardConfigResponse
     */
    type: RewardType;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof RewardConfigResponse
     */
    shouldEmailUser: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RewardConfigResponse
     */
    shouldEmailAdmin: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RewardConfigResponse
     */
    shouldSendNotificationWeb: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RewardConfigResponse
     */
    shouldSendNotificationDevourPlay: boolean;
    /**
     * 
     * @type {number}
     * @memberof RewardConfigResponse
     */
    amount?: number;
    /**
     * How many times one member may ever be granted this reward. Absent means no ceiling.
     * @type {number}
     * @memberof RewardConfigResponse
     */
    maxGrantsPerUser?: number;
    /**
     * 
     * @type {AmountUnit}
     * @memberof RewardConfigResponse
     */
    amountUnit?: AmountUnit;
    /**
     * 
     * @type {number}
     * @memberof RewardConfigResponse
     */
    durationAmount?: number;
    /**
     * 
     * @type {DurationUnit}
     * @memberof RewardConfigResponse
     */
    durationUnit?: DurationUnit;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    assetId?: string;
    /**
     * 
     * @type {AssetResponse}
     * @memberof RewardConfigResponse
     */
    asset?: AssetResponse;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    nftTrackerId?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    orderDiscountId?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    promoTokenId?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    questConfigId?: string;
    /**
     * LootBoxConfig ID granted for LOOTBOX reward type
     * @type {string}
     * @memberof RewardConfigResponse
     */
    lootBoxConfigId?: string;
    /**
     * 
     * @type {EmailTemplate}
     * @memberof RewardConfigResponse
     */
    emailTemplate?: EmailTemplate;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    claimFormUrl?: string;
    /**
     * When true, consumers render the platform inline RewardFulfillmentClaimForm (DB-backed shipping submission + ops Slack/email) instead of opening claimFormUrl. Used for physical-ship MERCH and manually-fulfilled GIFT_CARD rewards.
     * @type {boolean}
     * @memberof RewardConfigResponse
     */
    useInlineFulfillmentForm?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RewardConfigResponse
     */
    maxClaimCount?: number;
    /**
     * 
     * @type {string}
     * @memberof RewardConfigResponse
     */
    disclaimer?: string;
    /**
     * Hub ID for HUB_POINTS reward type
     * @type {string}
     * @memberof RewardConfigResponse
     */
    surfaceId?: string;
    /**
     * Tillo brand slug for gift card issuance (e.g. "starbucks-us")
     * @type {string}
     * @memberof RewardConfigResponse
     */
    tilloProductId?: string;
    /**
     * Human-readable brand name (e.g. "Starbucks")
     * @type {string}
     * @memberof RewardConfigResponse
     */
    tilloBrandName?: string;
    /**
     * Gift card face value in USD
     * @type {number}
     * @memberof RewardConfigResponse
     */
    giftCardAmount?: number;
    /**
     * Set true by catalog sync when brand/amount is no longer valid in Tillo
     * @type {boolean}
     * @memberof RewardConfigResponse
     */
    tilloConfigInvalid?: boolean;
    /**
     * Brand card-art URL (Tillo logo_url), persisted by catalog sync; the default GIFT_CARD reward visual when no assetId override is set.
     * @type {string}
     * @memberof RewardConfigResponse
     */
    tilloBrandLogoUrl?: string;
    /**
     * Resolved reward display image — the assigned reward graphic (asset) if set, otherwise a GIFT_CARD's brand card art. Render this instead of re-deriving image precedence.
     * @type {string}
     * @memberof RewardConfigResponse
     */
    imageUrl?: string;
    /**
     * 
     * @type {RewardProviderTier}
     * @memberof RewardConfigResponse
     */
    providerTier?: RewardProviderTier;
    /**
     * The owning brand for PARTNER-tier rewards.
     * @type {string}
     * @memberof RewardConfigResponse
     */
    ownerBrandId?: string;
    /**
     * Curation opt-in — only visible rows appear in self-serve pickers, and only when the type is on the self-serve shortlist.
     * @type {boolean}
     * @memberof RewardConfigResponse
     */
    selfServeVisible?: boolean;
}



/**
 * Check if a given object implements the RewardConfigResponse interface.
 */
export function instanceOfRewardConfigResponse(value: object): value is RewardConfigResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('shouldEmailUser' in value) || value['shouldEmailUser'] === undefined) return false;
    if (!('shouldEmailAdmin' in value) || value['shouldEmailAdmin'] === undefined) return false;
    if (!('shouldSendNotificationWeb' in value) || value['shouldSendNotificationWeb'] === undefined) return false;
    if (!('shouldSendNotificationDevourPlay' in value) || value['shouldSendNotificationDevourPlay'] === undefined) return false;
    return true;
}

export function RewardConfigResponseFromJSON(json: any): RewardConfigResponse {
    return RewardConfigResponseFromJSONTyped(json, false);
}

export function RewardConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': RewardTypeFromJSON(json['type']),
        'name': json['name'],
        'description': json['description'],
        'shouldEmailUser': json['shouldEmailUser'],
        'shouldEmailAdmin': json['shouldEmailAdmin'],
        'shouldSendNotificationWeb': json['shouldSendNotificationWeb'],
        'shouldSendNotificationDevourPlay': json['shouldSendNotificationDevourPlay'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'maxGrantsPerUser': json['maxGrantsPerUser'] == null ? undefined : json['maxGrantsPerUser'],
        'amountUnit': json['amountUnit'] == null ? undefined : AmountUnitFromJSON(json['amountUnit']),
        'durationAmount': json['durationAmount'] == null ? undefined : json['durationAmount'],
        'durationUnit': json['durationUnit'] == null ? undefined : DurationUnitFromJSON(json['durationUnit']),
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'asset': json['asset'] == null ? undefined : AssetResponseFromJSON(json['asset']),
        'nftTrackerId': json['nftTrackerId'] == null ? undefined : json['nftTrackerId'],
        'orderDiscountId': json['orderDiscountId'] == null ? undefined : json['orderDiscountId'],
        'promoTokenId': json['promoTokenId'] == null ? undefined : json['promoTokenId'],
        'questConfigId': json['questConfigId'] == null ? undefined : json['questConfigId'],
        'lootBoxConfigId': json['lootBoxConfigId'] == null ? undefined : json['lootBoxConfigId'],
        'emailTemplate': json['emailTemplate'] == null ? undefined : EmailTemplateFromJSON(json['emailTemplate']),
        'claimFormUrl': json['claimFormUrl'] == null ? undefined : json['claimFormUrl'],
        'useInlineFulfillmentForm': json['useInlineFulfillmentForm'] == null ? undefined : json['useInlineFulfillmentForm'],
        'maxClaimCount': json['maxClaimCount'] == null ? undefined : json['maxClaimCount'],
        'disclaimer': json['disclaimer'] == null ? undefined : json['disclaimer'],
        'surfaceId': json['surfaceId'] == null ? undefined : json['surfaceId'],
        'tilloProductId': json['tilloProductId'] == null ? undefined : json['tilloProductId'],
        'tilloBrandName': json['tilloBrandName'] == null ? undefined : json['tilloBrandName'],
        'giftCardAmount': json['giftCardAmount'] == null ? undefined : json['giftCardAmount'],
        'tilloConfigInvalid': json['tilloConfigInvalid'] == null ? undefined : json['tilloConfigInvalid'],
        'tilloBrandLogoUrl': json['tilloBrandLogoUrl'] == null ? undefined : json['tilloBrandLogoUrl'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'providerTier': json['providerTier'] == null ? undefined : RewardProviderTierFromJSON(json['providerTier']),
        'ownerBrandId': json['ownerBrandId'] == null ? undefined : json['ownerBrandId'],
        'selfServeVisible': json['selfServeVisible'] == null ? undefined : json['selfServeVisible'],
    };
}

export function RewardConfigResponseToJSON(json: any): RewardConfigResponse {
    return RewardConfigResponseToJSONTyped(json, false);
}

export function RewardConfigResponseToJSONTyped(value?: RewardConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': RewardTypeToJSON(value['type']),
        'name': value['name'],
        'description': value['description'],
        'shouldEmailUser': value['shouldEmailUser'],
        'shouldEmailAdmin': value['shouldEmailAdmin'],
        'shouldSendNotificationWeb': value['shouldSendNotificationWeb'],
        'shouldSendNotificationDevourPlay': value['shouldSendNotificationDevourPlay'],
        'amount': value['amount'],
        'maxGrantsPerUser': value['maxGrantsPerUser'],
        'amountUnit': AmountUnitToJSON(value['amountUnit']),
        'durationAmount': value['durationAmount'],
        'durationUnit': DurationUnitToJSON(value['durationUnit']),
        'assetId': value['assetId'],
        'asset': AssetResponseToJSON(value['asset']),
        'nftTrackerId': value['nftTrackerId'],
        'orderDiscountId': value['orderDiscountId'],
        'promoTokenId': value['promoTokenId'],
        'questConfigId': value['questConfigId'],
        'lootBoxConfigId': value['lootBoxConfigId'],
        'emailTemplate': EmailTemplateToJSON(value['emailTemplate']),
        'claimFormUrl': value['claimFormUrl'],
        'useInlineFulfillmentForm': value['useInlineFulfillmentForm'],
        'maxClaimCount': value['maxClaimCount'],
        'disclaimer': value['disclaimer'],
        'surfaceId': value['surfaceId'],
        'tilloProductId': value['tilloProductId'],
        'tilloBrandName': value['tilloBrandName'],
        'giftCardAmount': value['giftCardAmount'],
        'tilloConfigInvalid': value['tilloConfigInvalid'],
        'tilloBrandLogoUrl': value['tilloBrandLogoUrl'],
        'imageUrl': value['imageUrl'],
        'providerTier': RewardProviderTierToJSON(value['providerTier']),
        'ownerBrandId': value['ownerBrandId'],
        'selfServeVisible': value['selfServeVisible'],
    };
}

